import React, { useContext, useState } from "react";
import { Tabs } from "antd";
import { UserContext } from "../../../context/UserContext";
import RolesTable from "./RolesTable";
import PermissionsTable from "./PermissionsTable";

const RolesPermissionsTab = () => {
  const { userData } = useContext(UserContext);
  const [activeKey, setActiveKey] = useState("roles");

  return (
    <Tabs activeKey={activeKey} onChange={setActiveKey}>
      <Tabs.TabPane tab="Roles" key="roles">
        <RolesTable />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Permissions" key="permissions">
        <PermissionsTable />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default RolesPermissionsTab;
